import React from 'react';
import {createUseStyles} from 'react-jss';
import clsx from 'clsx';

import {chevronDown, infoIcon} from '../../common-styles/icons-style';
import {banksTableStyles, TABLE} from '../../common-styles/style-table';
import {currencyFormatter, getKzDateTime, platform} from '../../utils/helpers';
import {COLORS} from '../../utils/style-variables';
import {SberbankInfo} from '../sberbank-info';

const useStyles = createUseStyles({
  tableRow: {
    extend: TABLE.row,
    padding: '12px 16px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    color: COLORS.blackColor,
    '&.hidden': {
      display: 'none'
    },
    '&.open': {
      backgroundColor: COLORS.backgroundBlueColor
    },
    '@media (max-width: 768px)': {
      padding: '12px 8px'
    }
  },
  bankLogo: {
    display: 'inline-block',
    marginRight: 16,
    verticalAlign: 'middle',
    height: 32,
    '@media (max-width: 768px)': {
      marginRight: 8
    }
  },
  bankUpdateTime: {
    color: COLORS.greyColor
  },
  branchButton: {
    position: 'relative',
    paddingRight: 30,
    cursor: 'pointer',
    '@media (max-width: 768px)': {
      position: 'static',
      fontSize: 0
    },
    extend: chevronDown,
    '&.open': {
      '&:after': {
        transform: 'rotate(-45deg)',
        top: 'calc(50% - 3px)',
        '@media (max-width: 768px)': {
          top: 7,
          right: 2
        }
      }
    }
  },
  hint: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    padding: 16,
    right: 4,
    transform: 'translateX(50%)',
    backgroundColor: '#fff',
    borderRadius: '2px',
    borderColor: COLORS.lightGrey60Color,
    borderWidth: '1px',
    borderStyle: 'solid',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    boxShadow: '0px 2px 6px rgba(36, 36, 36, 0.3)',
    transition: 'opacity 250ms ease',
    zIndex: 1,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      borderColor: 'transparent',
      borderStyle: 'solid'
    },
    '&:before': {
      borderBottomWidth: 7,
      borderBottomColor: '#C4C4C4',
      borderLeftWidth: 5,
      borderRightWidth: 5
    },
    '&:after': {
      top: '-8px',
      borderBottomWidth: 6,
      borderBottomColor: '#FFFFFF',
      borderLeftWidth: 4,
      borderRightWidth: 4
    }
  },
  ...banksTableStyles,
  tableBranchColumn: {
    width: '150px',
    textAlign: 'right',
    userSelect: 'none',
    '@media (max-width: 768px)': {
      width: 20,
      height: 20
    }
  },
  informHint: {
    position: 'relative',
    cursor: 'pointer',
    extend: infoIcon,
    '&:before': {
      right: 3,
      width: 2,
      height: 9,
      borderTopWidth: 2,
      borderBottomWidth: 5
    },
    '&:after': {
      right: -4,
      width: 16,
      height: 16,
      borderWidth: 2
    },
    '&:hover $hint': {
      visibility: 'visible',
      opacity: 1
    }
  }
});

export const TableRow = ({bank, toggleBranch, openDropdown}) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.tableRow, {open: openDropdown})}
      onClick={() => toggleBranch(bank, platform.mobile)}
    >
      <div className={clsx(classes.tableColumn, classes.tableNameColumn)}>
        <span className={clsx(classes.bankLogo, bank.bankId)}>
          <img
            src={bank.bankLogoUrl}
            loading='lazy'
            width='32'
            height='32'
            alt={bank.bankTitle}
          />
        </span>
        <span>{bank.bankTitle}</span>
      </div>

      <div
        className={clsx(classes.tableColumn, classes.tableBuyColumn,
          {[classes.informHint]: bank.gradedRates && platform.desktop})}
      >
        <span>
          {currencyFormatter(bank.buy)}
        </span>
        {bank.gradedRates && bank.gradedRates.length && platform.desktop ?
          <div className={classes.hint}>
            <SberbankInfo gradesList={bank.gradedRates} operation='buy' />
          </div>
          : null}
      </div>
      <div
        className={clsx(classes.tableColumn, classes.tableSellColumn,
          {[classes.informHint]: bank.gradedRates && platform.desktop})}
      >
        <span>
          {currencyFormatter(bank.sell)}
        </span>
        {bank.gradedRates && bank.gradedRates.length && platform.desktop ?
          <div className={classes.hint}>
            <SberbankInfo gradesList={bank.gradedRates} operation='sell' />
          </div>
          : null}
      </div>
      <div className={clsx(classes.tableColumn, classes.tableUpdateColumn)}>
        <span
          className={classes.bankUpdateTime}
        >
          {bank.lastReceivedRatesTime ? getKzDateTime(bank.lastReceivedRatesTime, 'time') : '-'}
        </span>
      </div>
      <div className={clsx(classes.tableColumn, classes.tableBranchColumn)}>
        {bank.hasBranches &&
        <span
          className={clsx(classes.branchButton, {open: openDropdown})}
          onClick={() => toggleBranch(bank, platform.desktop)}
        >
          Отделения
        </span>
        }
      </div>
    </div>
  );
};
